import { type Context, createContext, useContext } from "react";

export interface DesktopAnnouncementModalController {
  openAnnouncementModal: (announcementId?: number) => void;
}

export const DesktopAnnouncementModalContext: Context<DesktopAnnouncementModalController> =
  createContext<DesktopAnnouncementModalController>({
    openAnnouncementModal: (): void => undefined,
  });

export function useDesktopAnnouncementModal(): DesktopAnnouncementModalController {
  return useContext(DesktopAnnouncementModalContext);
}
